import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '@reducers/user';
import { isScreenAvailable } from '@config/navigationRestrictions/helpers';
import { DashboardScreenName } from '@v2/pages/dashboard/navigation/config';

export const useDashboardAvailable = (): boolean => {
  const featureFlags = useSelector(selectFeatureFlags);
  return isScreenAvailable(DashboardScreenName, featureFlags);
};
